module.exports = __webpack_public_path__ + "static/media/schody12 - schody drewniane zabiegowe nakladane.a6ad60e1.jpg";